import React, { ReactNode, useEffect, useRef, useState } from 'react';
import './index.scss';

interface TabsProps {
  tabs: ReactNode[];
  trigger?: 'hover' | 'click';
  fixedIndicator?: boolean;
  className?: string;
}

const Tabs: React.FC<TabsProps> = ({ tabs, trigger, fixedIndicator, className, children }) => {
  const [current, setCurrent] = useState<number>(0);
  const [width, setWidth] = useState<number>(16);
  const [left, setLeft] = useState<number>();
  const tabsRef = useRef<HTMLDivElement>();

  useEffect(() => {
    const { left: containerLeft } = tabsRef.current.getBoundingClientRect();
    const { left, width } = tabsRef.current.querySelector('.active').getBoundingClientRect();
    if (fixedIndicator) {
      setLeft(left - containerLeft + width / 2 - 8);
    } else {
      const tabWidth = tabsRef.current.querySelector(`.tab:nth-child(${current + 1})`).getBoundingClientRect().width;
      setLeft(left - containerLeft);
      setWidth(tabWidth);
    }
  }, [current, fixedIndicator]);

  return (
    <div className={`tabs-container ${className || ''}`}>
      <div className="tabs" ref={tabsRef}>
        {tabs.map((item, index) => (
          <span
            key={index}
            className={`text-bold tab ${index === current ? 'active' : ''}`}
            role="button"
            onMouseEnter={() => trigger === 'hover' && setCurrent(index)}
            onClick={() => trigger === 'click' && setCurrent(index)}
          >
            {item}
          </span>
        ))}
        <span className={`indicator ${fixedIndicator ? 'fixed' : ''}`} style={{ left, width }} />
      </div>
      <div className="content">
        {React.Children.map(children, (child, index) => (
          <div key={index} style={{ display: current === index ? 'block' : 'none' }}>
            {child}
          </div>
        ))}
      </div>
    </div>
  );
};

Tabs.defaultProps = {
  trigger: 'hover',
  fixedIndicator: true,
};

export default Tabs;
